import { Text } from "@olivahealth/oli-ui";
import styles from "./styles.module.css";

interface SimplePill {
  key: string;
  title: string;
  starter?: string;
  icon?: string;
  careType?: string;
}

interface TopicPillProps {
  pillKey: string;
  pill: SimplePill;
  shouldAnimate: boolean;
  animationDelay: string;
  onClick: (pillKey: string, pill: SimplePill) => void;
}

export default function TopicPill({
  pillKey,
  pill,
  shouldAnimate,
  animationDelay,
  onClick,
}: TopicPillProps) {
  const animationClasses = shouldAnimate ? styles.fadeIn : styles.visible;

  return (
    <button
      onClick={() => onClick(pillKey, pill)}
      className={`${styles.pill} ${animationClasses}`}
      style={{ animationDelay: animationDelay }}
    >
      {pill.icon && <span>{pill.icon}</span>}
      <Text variant="body" color="light" weight="medium">
        {pill.title}
      </Text>
    </button>
  );
}

export type { SimplePill, TopicPillProps };
